"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledThrobber = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var Throbber = /*#__PURE__*/_react["default"].memo(function (props) {
  var _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      _props$size = props.size,
      size = _props$size === void 0 ? 50 : _props$size,
      _props$thickness = props.thickness,
      thickness = _props$thickness === void 0 ? 2 : _props$thickness,
      _props$color = props.color,
      color = _props$color === void 0 ? '' : _props$color,
      _props$embed = props.embed,
      embed = _props$embed === void 0 ? false : _props$embed;
  return /*#__PURE__*/_react["default"].createElement(StyledThrobber, {
    className: className,
    size: size,
    thickness: thickness,
    color: color,
    embed: embed
  });
});

Throbber.displayName = 'Throbber';
var spin = (0, _styledComponents.keyframes)(["from{transform:rotate(0deg);}to{transform:rotate(360deg);}"]);

var StyledThrobber = _styledComponents["default"].div.withConfig({
  displayName: "Throbber__StyledThrobber",
  componentId: "sc-1bntrqf-0"
})(["width:100%;height:100%;margin:0 auto;display:block;top:0;left:0;", "::before{width:", ";height:", ";content:'';position:absolute;border-radius:100%;top:calc(50% - ", ");left:calc(50% - ", ");border:solid;border-width:", ";border-color:", ";border-left-color:rgba(255,255,255,0.3);border-bottom-color:rgba(255,255,255,0.3);animation:", " 0.5s linear infinite;}"], function (props) {
  return "".concat(props.embed ? "position: relative;" : "position: absolute;");
}, function (props) {
  return "".concat(props.size, "px");
}, function (props) {
  return "".concat(props.size, "px");
}, function (_ref) {
  var size = _ref.size,
      thickness = _ref.thickness;
  return "".concat(size / 2 + thickness, "px");
}, function (_ref2) {
  var size = _ref2.size;
  return "".concat(size / 2, "px");
}, function (props) {
  return "".concat(props.thickness, "px");
}, function (props) {
  return props.color ? props.theme.colors[props.color] || props.color : props.theme.colors.white;
}, spin);

exports.StyledThrobber = StyledThrobber;
var _default = Throbber;
exports["default"] = _default;